import { render, staticRenderFns } from "./DispatchSection.vue?vue&type=template&id=dbbac728&scoped=true&"
import script from "./DispatchSection.vue?vue&type=script&lang=js&"
export * from "./DispatchSection.vue?vue&type=script&lang=js&"
import style0 from "./DispatchSection.vue?vue&type=style&index=0&id=dbbac728&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbac728",
  null
  
)

export default component.exports